'use client';

export { default } from './IconButton';
export { default as iconButtonClasses } from './iconButtonClasses';
export * from './iconButtonClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/IconButton/index.js
// module id = 81
// module chunks = 25